import React from "react";

export default function RunwayBlock(props) {
  const {
    activeSide,
    isCrosswind,
    le_ident,
    he_ident,
    scaleX,
    scaleY,
    he_heading,
    originY,
    svgWidth,
    svgHeight,
    rwyX,
    rwyY,
    scaleWidth,
    scaleLength,
    rwyLineBottomX,
    rwyLineBottomY,
    rwyLineTopX,
    rwyLineTopY,
    originAtCenter,
  } = props;

  const mark1Width = (scaleWidth / 2) * 0.5;
  const mark2Width = scaleWidth / 2;

  const activeColor = isCrosswind
    ? "rgba(245,158,11,0.7)"
    : "rgba(0,232,122,0.7)";

  return (
    <svg
      className="runway"
      style={{
        position: "absolute",
        userSelect: "none",
        zIndex: 1,
        transform: `${
          !originAtCenter
            ? `translate(${scaleX}px, calc(${scaleY}px - 50%))`
            : ""
        } rotate(${he_heading}deg)`,
        transformOrigin: !originAtCenter ? `center ${originY}px` : undefined,
      }}
      viewBox={`0 0 ${svgWidth} ${svgHeight}`}
      width={svgWidth}
      height={svgHeight}
      xmlns="http://www.w3.org/2000/svg"
    >
      {activeSide === "le" ? (
        <pattern
          id={"arrow" + le_ident}
          x={0}
          y={0}
          width={1}
          height={0.1}
          viewBox={`0 0 ${scaleWidth} 40`}
          patternUnits="objectBoundingBox"
        >
          <animateTransform
            attributeType="xml"
            attributeName="patternTransform"
            type="translate"
            dur="1.2s"
            values={`0,0; 0,${scaleLength * 0.1}`}
            repeatCount="indefinite"
          />
          <path
            fill={activeColor}
            d={`M${0},${0} l${scaleWidth / 2},${20} l${scaleWidth / 2},${-20} l${0},${20} l${-scaleWidth / 2},${20} l${-scaleWidth / 2},${-20} l${0},${-20}`}
          />
        </pattern>
      ) : activeSide === "he" ? (
        <pattern
          id={"arrow" + he_ident}
          x={0}
          y={0}
          width={1}
          height={0.1}
          viewBox={`0 0 ${scaleWidth} 40`}
          patternUnits="objectBoundingBox"
        >
          <animateTransform
            attributeType="xml"
            attributeName="patternTransform"
            type="translate"
            dur="1.2s"
            values={`0,0; 0,-${scaleLength * 0.1}`}
            repeatCount="indefinite"
          />
          <path
            fill={activeColor}
            d={`M${0},${40} l${scaleWidth / 2},${-20} l${scaleWidth / 2},${20} l${0},${20} l${-scaleWidth / 2},${-20} l${-scaleWidth / 2},${20} l${0},${-20}`}
          />
        </pattern>
      ) : null}

      <pattern
        id={`mark${le_ident}`}
        x={rwyX + 2}
        y={rwyY}
        width={4}
        height="20"
        patternUnits="userSpaceOnUse"
      >
        <line x1={0} y1={0} x2={0} y2={20} strokeWidth={3} stroke="#555" />
      </pattern>
      <defs>
        <g id={`mark1${le_ident}`}>
          <line x1={mark1Width / 3} y1={0} x2={mark1Width / 3} y2={15} stroke="#555" strokeWidth="1" />
          <line x1={(mark1Width / 3) * 2} y1={0} x2={(mark1Width / 3) * 2} y2={15} stroke="#555" strokeWidth="1" />
          <line x1={(mark1Width / 3) * 3} y1={0} x2={(mark1Width / 3) * 3} y2={15} stroke="#555" strokeWidth="1" />
        </g>
        <g id={`mark2${le_ident}`}>
          <line x1={mark2Width / 4} y1={0} x2={mark2Width / 4} y2={15} stroke="#555" strokeWidth="1" />
          <line x1={mark2Width / 2} y1={0} x2={mark2Width / 2} y2={15} stroke="#555" strokeWidth="1" />
        </g>
      </defs>

      <g>
        {/* Runway surface */}
        <rect x={rwyX} y={rwyY} width={scaleWidth} height={scaleLength} fill="#1a1a2e" rx="3" />
        {/* Runway border */}
        <rect x={rwyX} y={rwyY} width={scaleWidth} height={scaleLength} stroke="rgba(0,212,255,0.3)" strokeWidth="1.5" fill="none" rx="3" />
        {/* Active arrow overlay */}
        {activeSide && (
          <rect
            x={rwyX}
            y={rwyY}
            width={scaleWidth}
            height={scaleLength}
            stroke="none"
            fill={`url(#arrow${activeSide === "le" ? le_ident : he_ident})`}
            rx="3"
          />
        )}
        {/* Markings */}
        <rect fill={`url(#mark${le_ident})`} x={rwyX} y={rwyY + 10} width={scaleWidth} height={20} />
        <use x={rwyX} y={rwyY + 60} href={`#mark1${le_ident}`} />
        <use x={rwyX + scaleWidth / 1.5} y={rwyY + 60} href={`#mark1${le_ident}`} />
        <use x={rwyX} y={rwyY + 120} href={`#mark2${le_ident}`} />
        <use x={rwyX + scaleWidth / 1.5 - 1} y={rwyY + 120} href={`#mark2${le_ident}`} />
        <rect fill={`url(#mark${le_ident})`} x={rwyX} y={rwyY + scaleLength - 30} width={scaleWidth} height={20} />
        <use x={rwyX} y={rwyY + scaleLength - 75} href={`#mark1${le_ident}`} />
        <use x={rwyX + scaleWidth / 1.5} y={rwyY + scaleLength - 75} href={`#mark1${le_ident}`} />
        <use x={rwyX} y={rwyY + scaleLength - 135} href={`#mark2${le_ident}`} />
        <use x={rwyX + scaleWidth / 1.5 - 1} y={rwyY + scaleLength - 135} href={`#mark2${le_ident}`} />
        {/* Centerline dashes */}
        <path
          stroke="rgba(0,212,255,0.25)"
          strokeDasharray="12 8"
          strokeWidth={1.5}
          d={`M ${rwyLineTopX},${rwyLineTopY} L ${rwyLineBottomX},${rwyLineBottomY}`}
        />
      </g>
    </svg>
  );
}
